import { Navigate, useLocation } from 'react-router-dom';
import authService from '../services/AuthService';
import { debugLog } from '../utils/debugUtils';

const IS_DEBUG = process.env.REACT_APP_DEBUG_MODE === 'true';

export default function ProtectedRoute({ children }) {
  const location = useLocation();

  if (IS_DEBUG) {
    // In debug mode: persist a mock user if not already authenticated
    if (!authService.isAuthenticated()) {
      authService.login('debug@concordare.dev', 'debug');
      debugLog('[ProtectedRoute] DEBUG MODE — auto-logged in as mock user');
    }
    return children;
  }

  if (!authService.isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  return children;
}
